import React from "react";

const FormButtons = ({
  caseDetails,
  user,
  stepDetails,
  handleNextButtonClick,
  handleSaveAndNext,
  handleSaveAsDraft,
  isVerificationRequired,
  isReadOnlyUser,
}) => {
  const { btnDisplayMaker, firstBtnText } = stepDetails;
  return (
    <div className="clearfix dts-save-details">
      <div className="pull-right">
        {!isVerificationRequired && (
          <div className="clearfix">
            <div className="pull-right">
              {!isReadOnlyUser && user.user_id === caseDetails.maker_id ? (
                <button
                  type="button"
                  className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                  onClick={handleNextButtonClick}
                >
                  <span className="fa fa-save font-14 mrg-R5"></span>
                  Next
                </button>
              ) : (
                <button
                  type="button"
                  className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                  onClick={handleNextButtonClick}
                >
                  <span className="fa fa-arrow-right font-14 mrg-R5"></span>
                  Next
                </button>
              )}
            </div>
          </div>
        )}
        {isVerificationRequired && (
          <div className="clearfix">
            <div className="pull-right">
              {!isReadOnlyUser && btnDisplayMaker ? (
                <>
                  <button
                    type="button"
                    className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                    onClick={handleSaveAsDraft}
                  >
                    <span className="fa fa-save font-14 mrg-R5"></span>
                    {firstBtnText}
                  </button>
                  <button
                    type="button"
                    className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                    onClick={handleSaveAndNext}
                  >
                    <span className="fa fa-save font-14 mrg-R5"></span>
                    Save and next
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5"
                  onClick={handleNextButtonClick}
                >
                  <span className="fa fa-arrow-right font-14 mrg-R5"></span>
                  Next
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormButtons;
